import React from 'react';
import styles from './Paging.module.scss';
import { GreenButton } from '../GreenButton/GreenButton';
import { TransparentButton } from '../TransparentButton/TransparentButton';
import { PAGE_OPTIONS } from '../../../constants';

interface IPaging {
    totalRecords: number;
    pageNumber: number;
    pageSize: number;
    changePage: (pageNumber: number) => void;
    changePageSize: (pageSize: number) => void;
}

export const Paging = ({ totalRecords, pageNumber, pageSize, changePage, changePageSize }: IPaging) => {
    const pageCount = Math.ceil(totalRecords / pageSize);
    
    // Функция для генерации массива страниц с многоточиями
    const getPageNumbers = (): (number | string)[] => {
        const delta = 2; // Сколько страниц показывать вокруг текущей
        const pages: (number | string)[] = [];
        
        if (pageCount <= 7) {
            // Если страниц мало, показываем все
            return Array.from({ length: pageCount }, (_, i) => i + 1);
        }
        
        // Всегда показываем первую страницу
        pages.push(1);
        
        // Определяем диапазон страниц вокруг текущей
        const rangeStart = Math.max(2, pageNumber - delta);
        const rangeEnd = Math.min(pageCount - 1, pageNumber + delta);
        
        // Добавляем многоточие после первой страницы, если нужно
        if (rangeStart > 2) {
            pages.push('...');
        }
        
        // Добавляем страницы вокруг текущей
        for (let i = rangeStart; i <= rangeEnd; i++) {
            pages.push(i);
        }
        
        // Добавляем многоточие перед последней страницей, если нужно
        if (rangeEnd < pageCount - 1) {
            pages.push('...');
        }
        
        // Всегда показываем последнюю страницу
        if (pageCount > 1) {
            pages.push(pageCount);
        }
        
        return pages;
    };

    const pages = getPageNumbers();

    return (
        <div className={styles.container}>
            <div className={styles.leftBlock}>
                {/* Кнопка "Предыдущая" */}
                {pageNumber > 1 && (
                    <TransparentButton
                        onClick={() => changePage(pageNumber - 1)}
                    >
                        ←
                    </TransparentButton>
                )}
                
                {pages.map((page, idx) =>
                    typeof page === 'string' ? (
                        <span key={`ellipsis-${idx}`} className={styles.ellipsis}>
                            {page}
                        </span>
                    ) : page === pageNumber ? (
                        <GreenButton key={page}>{`${page}`}</GreenButton>
                    ) : (
                        <TransparentButton
                            onClick={() => changePage(page)}
                            key={page}
                        >
                            {`${page}`}
                        </TransparentButton>
                    )
                )}
                
                {/* Кнопка "Следующая" */}
                {pageNumber < pageCount && (
                    <TransparentButton
                        onClick={() => changePage(pageNumber + 1)}
                    >
                        →
                    </TransparentButton>
                )}
            </div>
            <div className={styles.rightBlock}>
                <div className={styles.text}>On Page:</div>
                <div className={styles.text}>
                    <select
                        className={styles.select}
                        value={pageSize}
                        onChange={(e) => {
                            changePageSize(Number(e.target.value));
                        }}
                    >
                        {PAGE_OPTIONS.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={styles.text}>
                    Records: <strong>{totalRecords}</strong>
                </div>
            </div>
        </div>
    );
};
